import { Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { AppProvider } from "../context/app-context.tsx";
import { SettingsProvider } from "../context/settings-context.tsx";
import { SessionProvider, useSession } from "../context/session-context.tsx";
import { installScannerBridge } from "../scanner-bridge.ts";
import { ScanDebug } from "../components/scan-debug.tsx";

const showDebug =
  typeof window !== "undefined" && new URLSearchParams(window.location.search).has("debug");

/**
 * Thin always-on strip naming the company this device scans for, in the company's
 * accent colour — so an operator can never be in doubt which business they're in.
 * Renders nothing until the session resolves (or if it can't).
 */
function CompanyBanner() {
  const session = useSession();
  if (!session) return null;
  return (
    <div
      style={{ backgroundColor: session.accent }}
      className="shrink-0 px-3 py-0.5 text-center text-xs font-semibold tracking-wide text-white"
    >
      {session.displayName}
    </div>
  );
}

export function Root() {
  useEffect(() => {
    installScannerBridge();
  }, []);

  return (
    <AppProvider>
      <SettingsProvider>
        <SessionProvider>
          {showDebug && <ScanDebug />}
          <div className="flex h-full flex-col bg-gray-950 text-white">
            <CompanyBanner />
            <Outlet />
          </div>
        </SessionProvider>
      </SettingsProvider>
    </AppProvider>
  );
}
